// frontend/src/utils/prorataExercice.js
// Miroir de backend/src/utils/prorataExercice.js — meme regle de prorata
// jour/jour pour aligner les totaux affiches avec le CERFA ERA/TIC-VA.

export function parseDateFr(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null;
  const parts = dateStr.match(/(\d{1,2})[\/\.](\d{1,2})[\/\.](\d{2,4})/);
  if (!parts) return null;
  let day = parseInt(parts[1], 10);
  let month = parseInt(parts[2], 10) - 1;
  let year = parseInt(parts[3], 10);
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  if (year < 100) year += 2000;
  const d = new Date(year, month, day);
  if (d.getFullYear() !== year || d.getMonth() !== month || d.getDate() !== day) return null;
  return d;
}

export function parseDateIso(dateStr) {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return isNaN(dateStr.getTime()) ? null : dateStr;
  const m = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const d = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
  return isNaN(d.getTime()) ? null : d;
}

export function countDays(start, end) {
  if (!start || !end || start > end) return 0;
  const s = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const e = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  return Math.round((e.getTime() - s.getTime()) / 86400000) + 1;
}

/**
 * Retourne un facteur [0..1] reflectant la part d'une periode de facture
 * qui tombe dans l'exercice fiscal. Retourne 0 si hors bornes ou periode invalide.
 */
export function calculerProrataSurExercice({ periode, dateDebutExercice, dateFinExercice }) {
  if (!periode || typeof periode !== 'string' || !periode.includes(' - ')) return 0;

  const debutExo = dateDebutExercice instanceof Date ? dateDebutExercice : parseDateIso(dateDebutExercice);
  const finExo   = dateFinExercice   instanceof Date ? dateFinExercice   : parseDateIso(dateFinExercice);
  if (!debutExo || !finExo || debutExo > finExo) return 0;

  const [debutStr, finStr] = periode.split(' - ').map(s => s.trim());
  const debutFacture = parseDateFr(debutStr);
  const finFacture   = parseDateFr(finStr);
  if (!debutFacture || !finFacture || debutFacture > finFacture) return 0;

  const debutEffective = debutFacture < debutExo ? debutExo : debutFacture;
  const finEffective   = finFacture   > finExo   ? finExo   : finFacture;
  if (debutEffective > finEffective) return 0;

  const joursTotalFacture = countDays(debutFacture, finFacture);
  if (joursTotalFacture === 0) return 0;

  return countDays(debutEffective, finEffective) / joursTotalFacture;
}
